const profile =
{
    default: {
        logoSeparation: "/assets/img/common/logo_separation.svg",
        logoAozora: "/assets/img/common/logo_aozora.svg",
        logo:"/assets/img/common/logo.svg",
        logoSp: "/assets/img/common/logo_sp.svg",
        srcNavWorks: "/assets/img/common/nav_works.svg",
        srcNavAbout: "/assets/img/common/nav_about.svg",
        srcNavYamadashimpei: "/assets/img/common/nav_yamadashimpei.svg",
        srcNavAozora: "/assets/img/common/nav_aozora.svg",
        srcNavHiyamizu: "/assets/img/common/nav_hiyamizu.svg",
        srcNavProfile: "/assets/img/common/nav_profile.svg",
        srcNavContact: "/assets/img/common/nav_contact.svg",
        srcNavWorksAll: "/assets/img/common/nav_works_all.svg",
        srcNavWorksTheater: "/assets/img/common/nav_works_theater.svg",
        srcNavWorksProjectionWork: "/assets/img/common/nav_works_projection_work.svg",
        srcNavWorksArtProject: "/assets/img/common/nav_works_art_project.svg",
        srcNavWorksWorkshop: "/assets/img/common/nav_works_workshop.svg",
        srcNavWorksTechnicalWork: "/assets/img/common/nav_works_technical_work.svg",
        srcNavWorksExhibition: "/assets/img/common/nav_works_exhibition.svg",
        srcNavWorksToyohashi: "/assets/img/common/nav_works_toyohashi.svg"
    },
    white: {
        logoSeparation: "/assets/img/common/black/logo_separation.svg",
        logoAozora: "/assets/img/common/black/logo_aozora.svg",
        logo:"/assets/img/common/black/logo.svg",
        logoSp: "/assets/img/common/black/logo_sp.svg",
        srcNavWorks: "/assets/img/common/black/nav_works.svg",
        srcNavAbout: "/assets/img/common/black/nav_about.svg",
        srcNavYamadashimpei: "/assets/img/common/black/nav_yamadashimpei.svg",
        srcNavAozora: "/assets/img/common/black/nav_aozora.svg",
        srcNavHiyamizu: "/assets/img/common/black/nav_hiyamizu.svg",
        srcNavProfile: "/assets/img/common/black/nav_profile.svg",
        srcNavContact: "/assets/img/common/black/nav_contact.svg",
        srcNavWorksAll: "/assets/img/common/black/nav_works_all.svg",
        srcNavWorksTheater: "/assets/img/common/black/nav_works_theater.svg",
        srcNavWorksProjectionWork: "/assets/img/common/black/nav_works_projection_work.svg",
        srcNavWorksArtProject: "/assets/img/common/black/nav_works_art_project.svg",
        srcNavWorksWorkshop: "/assets/img/common/black/nav_works_workshop.svg",
        srcNavWorksTechnicalWork: "/assets/img/common/black/nav_works_technical_work.svg",
        srcNavWorksExhibition: "/assets/img/common/black/nav_works_exhibition.svg",
        srcNavWorksToyohashi: "/assets/img/common/black/nav_works_toyohashi.svg"
    }
}

export const getHeaderContents = (selectTheme) => {
    const theme = profile.hasOwnProperty(selectTheme) ? selectTheme : 'default';
    return profile[theme];
}
